module.exports = __webpack_public_path__ + "img/mswa.0b37e1c.png";